import { render, staticRenderFns } from "./BindTipsDialog.vue?vue&type=template&id=7093e3ca&scoped=true"
import script from "./BindTipsDialog.vue?vue&type=script&lang=js"
export * from "./BindTipsDialog.vue?vue&type=script&lang=js"
import style0 from "./BindTipsDialog.vue?vue&type=style&index=0&id=7093e3ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7093e3ca",
  null
  
)

export default component.exports